import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Tooltip,
  useEventCallback,
} from '@mui/material';
import { memo, useEffect } from 'react';
import { PmiInputFile } from 'shell/components/shared/file-input';
import DeleteIcon from '@mui/icons-material/Delete';
import { DocumentSectionVM } from 'cancellations/view-models/cancellation-aire';
import { FileExtended } from 'shell/view-models/edit-data-control-person';

interface FormProps {
  disabled?: boolean;
  onChange: (
    key: keyof DocumentSectionVM,
    value: DocumentSectionVM[keyof DocumentSectionVM]
  ) => void;
  onChanges: (values: DocumentSectionVM) => void;
  values?: DocumentSectionVM;
}

const FormComponent = ({
  disabled,
  onChange,
  values,
  onChanges,
}: FormProps): React.ReactElement => {
  useEffect(() => {
    if (values?.isNotDocument) {
      // reset files
      onChanges({
        ...(values || {}),
        files: undefined,
      });
    }
  }, [values?.isNotDocument]);

  const handleAddFile = useEventCallback((files: Array<File>) => {
    const reader = new FileReader();
    reader.addEventListener('load', (event) => {
      const { result } = event.target || {};

      const newFiles: Array<FileExtended> = values?.files?.slice() || [];

      const [newFile] = files || [];

      const filesInsert: Array<FileExtended> = [
        {
          ...newFile,
          name: newFile.name,
          type: newFile.type,
          raw: result as string,
        },
      ];

      onChanges({
        ...(values || {}),
        files: newFiles.concat(filesInsert),
      });
    });

    reader.readAsDataURL(files[0]);
  });

  const onTrashPress = useEventCallback((indexCurr: number) => {
    const newFiles: Array<FileExtended> =
      (values?.files || []).filter((_, index) => index !== indexCurr) || [];

    onChange('files', newFiles);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              id="isTranscribed"
              checked={values?.isNotDocument || false}
              onChange={() => onChange('isNotDocument', !values?.isNotDocument)}
              inputProps={{ 'aria-label': 'Non sono presenti documenti da allegare alla pratica' }}
              disabled={disabled}
            />
          }
          label="Non sono presenti documenti da allegare alla pratica"
        />
      </Grid>
      <Grid item xs={12}>
        Carica documento&nbsp;
        <PmiInputFile
          files={values?.files}
          onChange={handleAddFile}
          color="cdmBrandThird"
          multiple
          hideList
          disabled={disabled || values?.isNotDocument}
          accept="application/pdf, image/*"
        />
      </Grid>
      <Grid item xs={12}>
        {values?.files?.map((file, index) => (
          <Grid container spacing={2} item xs={12} key={`file-${file.name}-${index}`}>
            <Grid item xs={12} md={4}>
              <Tooltip arrow title={file.name ? file.name : ''}>
                <a download={file.name} href={file.raw}>
                  {file.name}
                </a>
              </Tooltip>
            </Grid>
            <Grid item xs={12} md={5}>
              <IconButton
                color="error"
                aria-label="eliminare documento allegato"
                component="span"
                onClick={() => onTrashPress(index)}
                disabled={disabled}
              >
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

FormComponent.displayName = 'Upload Document section';

const Form = memo(FormComponent);

export default Form;
